'use client'

import { createContext, useContext } from 'react'
import { useAuthButtonBridge } from './AuthButtonBridge.context'
import { useWeb3Ready } from './Web3ReadyContext'

export interface PrivyAuthContextType {
  triggerLogin: (options?: {
    onActionClick?: () => void
    onAuthSuccess?: () => void
    prefillEmail?: string
    referrerEmail?: string
  }) => void
  triggerLogout: () => void
  isAuthenticated: boolean
  isLoading: boolean
}

export const PrivyAuthContext = createContext<PrivyAuthContextType | undefined>(undefined)

const defaultPrivyAuth: PrivyAuthContextType = {
  triggerLogin: () => {},
  triggerLogout: () => {},
  isAuthenticated: false,
  isLoading: true,
}

export const usePrivyAuth = (): PrivyAuthContextType => {
  const context = useContext(PrivyAuthContext)
  const bridge = useAuthButtonBridge()
  const web3Ready = useWeb3Ready()

  // When real provider not mounted (deferred Web3), use bridge so "Log in" click
  // queues the login intent AND triggers the Web3 chunk to load.
  if (context === undefined) {
    return {
      ...defaultPrivyAuth,
      triggerLogin: (opts) => {
        web3Ready?.activate()
        bridge?.triggerLogin(opts)
      },
    }
  }
  return context
}
